import useShared from "../../../../../shared/_common/_shared";

export default function ExcotradesEmptyData() {
    const {IconCommon} = useShared()

    return (
         <div className={"text-center flex justify-center"}>
            <IconCommon iconName={"empty"} className={"empty-data"} title={"noData"} isAlwaysInActive/>
        </div>
    )
}